module.exports = __webpack_public_path__ + "img/Bitmap7.e65a9283.png";